import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, List, ListItem, ListItemButton, ListItemIcon, ListItemText, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { Apellido } from './Apellido';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

export interface IApellidoNewProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
}

export interface IApellidoNewState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    errors: any[];
}

export default class ApellidoNew extends React.Component<IApellidoNewProps, IApellidoNewState> {
    _apellido: Apellido = new Apellido();
    
    public constructor(props: IApellidoNewProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            errors: []
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IApellidoNewProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open && this.state.errors.length == 0} fullWidth>
                    <DialogTitle>
                        Nuevo apellido
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Apellido' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._apellido.apellido = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Save.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.errors.length > 0} fullWidth>
                    <DialogTitle>
                        Error
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant='body2'>
                            Se ha producido el siguiente error al guardar los datos:
                        </Typography>
                        <div className='errors'>
                            <List>
                                {
                                    this.state.errors.map((value: string, index: number) => {
                                        return (
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <CancelOutlinedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary={value} />
                                                </ListItemButton>
                                            </ListItem>
                                        )
                                    })
                                }
                            </List>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            this.setState(
                                {
                                    errors: []
                                }
                            );
                        }}>Ok</Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Save() {
        if(this._apellido.apellido == '' || this._apellido.apellido == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/apellidos`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._apellido),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._apellido = new Apellido();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._apellido = new Apellido();
        });
    }
}